/* src/config/images.js */

import axios from 'axios';
import { adminDomain } from './settings';
import { getAdminToken } from './localstore';
import { getNetworkInfo } from '../util/network';
import Storage from '../util/storage';

const transcriptURL = `${adminDomain}/images/transcript`;
const signatureURL = `${adminDomain}/images/signature`;
const {
  tp,
  tp_ws: ws,
  domain,
  endpoints: { nimbus: nep, subscription: sep },
} = getNetworkInfo();
const dom = `${tp}${domain}`;

const getImage = (url, token, params = {}) =>
  axios({
    method: 'get',
    url,
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const postImage = (url, formdata) => {
  /*
  for (var value of formdata.values()) {
    // console.log('formdaaaaa', value);
  }
  */
  /*
  return Storage.getToken()
    .then(token => axios({
      method: 'post',
      url: `${dom}${url}`,
      data: formdata,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    }));
  */
  return axios({
    method: 'post',
    url: `${dom}${url}`,
    data: formdata,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${global.__token_nim}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

//   return RNFetchBlob.fetch('GET', url, headers)
//     .then(response => {
//       if (response.respInfo.status === 404)
//         return Promise.reject(new Error('image not found'));
//       const base64Str = response.base64();
//       return Promise.resolve(`data:image/jpeg;base64,${base64Str}`);
//     });
// };

export const getTranscript = (id, page) =>
  getAdminToken().then(token => getImage(transcriptURL, token, { id, page }));

export const getSignature = (id, page) =>
  getAdminToken().then(token => getImage(signatureURL, token, { id, page }));



// WEBPACK FOOTER //
// ./src/config/images.js